import React, { FC, HTMLAttributes } from 'react';

import { Typography } from '@common/styles';

import { useProductCardContext } from '../../../context/ProductCardContext';
import { Root } from './Discount.styled';

/**
 * 상품 컴포넌트의 할인 정보
 */
export const Discount: FC<React.PropsWithChildren<HTMLAttributes<HTMLParagraphElement>>> = (props) => {
  const { discount_info, max_price } = useProductCardContext();
  if (!discount_info || !discount_info.title) {
    return null;
  }

  return (
    <Root {...props}>
      <span className={`discount-type ${Typography.CAPTION_11_BOLD}}`}>{discount_info.title}</span>
      <span className={`original-price ${Typography.CAPTION_10_MEDIUM}`}>{max_price.toLocaleString('ko-KR')}</span>
    </Root>
  );
};
